import React from "react";
import {
  Autocomplete,
  Checkbox,
  ListItemText,
  MenuItem,
  Popper,
  TextField,
} from "@mui/material";
import "./ReuseableComponent.css";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const GCAutocompleteCheckboxFixSize = ({
  options = [],
  xValue = [],
  xtabIndex = "",
  xDisabled = false,
  setValue,
  objName,
  label,
  placeholder,
}) => {
  return (
    <div
      className="GCAutocompleteCheckboxFixSize"
      style={{ background: xDisabled ? "#e9ecef" : "transparent" }}
    >
      <Autocomplete
        tabIndex={xDisabled ? "" : xtabIndex}
        disabled={xDisabled}
        multiple
        size="small"
        options={options || []}
        getOptionLabel={(option) => option?.Name1 || ""}
        value={
          options?.filter((grp) =>
            Array.isArray(xValue) ? xValue.includes(grp.Cd) : []
          ) || []
        }
        isOptionEqualToValue={(option, value) => option.Cd === value.Cd}
        onChange={(event, newValue) => {
          const selectedGrps = newValue.map((grp) => grp.Cd);
          setValue((prev) => ({ ...prev, [objName]: selectedGrps }));
        }}
        disableCloseOnSelect
        PopperComponent={(props) => {
          return (
            <Popper
              {...props}
              style={{
                zIndex: 1300,
                width: props.anchorEl ? props.anchorEl.clientWidth : "auto", // Set width same as the Autocomplete field
              }}
              placement="bottom-start"
            />
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              fontSize: "12px",
              "& .MuiOutlinedInput-root": {
                maxHeight: "32px",
                overflowY: "auto",
                border: "1px solid #ddd",
                padding: "0px !important",
                minWidth: "0px !important",
              },
              "& .MuiAutocomplete-input": {
                padding: "7.5px 4px 7.5px 5px !important",
              },
            }}
          />
        )}
        renderOption={(props, option, { selected }) => (
          <MenuItem
            {...props}
            key={option?.Cd}
            sx={{
              height: "31px",
              minHeight: "31px",
              padding: "0 8px",
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Checkbox
              size="small"
              icon={icon}
              checkedIcon={checkedIcon}
              checked={selected}
            />
            <ListItemText
              primary={option?.Name1}
              primaryTypographyProps={{
                fontSize: "12px",
                lineHeight: "1.2",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            />
          </MenuItem>
        )}
      />
    </div>
  );
};
export default GCAutocompleteCheckboxFixSize;
